import React from "react";
import { useState } from "react";
import { Col, Container, Pagination, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import Heading from "../../components/Ui/Heading";
import ProductCard from "../../components/Ui/ProductCard";
import { useGetAllProductsQuery } from "../../redux/products/productsApi";

const SearchingProducts = ({ setShow }) => {
  const { data: products, isLoading, isError } = useGetAllProductsQuery();
  const { searchText } = useSelector((state) => state.searchText);

  let content = null;
  if (isLoading) {
    content = <p>Loading...</p>;
  }
  if (!isLoading && isError) {
    content = (
      <h3 className="text-danger text-center">There is something wrong</h3>
    );
  }
  if (!isLoading && !isError && products?.result?.length === 0) {
    content = <h3 className="text-danger text-center">There is data</h3>;
  }
  if (!isLoading && !isError && products?.result?.length > 0) {
    content = products?.result
      ?.filter((p) => {
        return p.name.toLowerCase().includes(searchText.toLowerCase());
      })
      ?.map((product) => (
        <Col key={product?._id}>
          {" "}
          <ProductCard setShow={setShow} cart={product} />
        </Col>
      ));
  }
  const [activeValue, setActiveValue] = useState(1);
  let active = activeValue;
  let items = [];
  for (let number = 1; number <= 5; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === active}
        onClick={() => setActiveValue(number)}
      >
        {number}
      </Pagination.Item>
    );
  }
  return (
    <Container>
      <Heading className="text-center">Searched Products</Heading>
      <Row xs={2} sm={2} md={4} className="g-4">
        {content}
      </Row>
      <div className="d-flex justify-content-center mt-4">
        <Pagination>{items}</Pagination>
      </div>
    </Container>
  );
};

export default SearchingProducts;
